const bgImage = (src) => {
  const bgStyle = {
    backgroundImage: 'url(' + src + ')',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center'
  };
  return bgStyle;
};

export default bgImage;



// WEBPACK FOOTER //
// ./src/scripts/bg-image.js